import React from 'react';
import { Link } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import './Navigation.css';
import remfeeLogo from '../assets/remfee-logo.png'; // Import the logo

function Navigation({ isLoggedIn, userEmail, onShowSignupModal }) {
  const handleLogout = async () => {
    try {
      const auth = getAuth();
      await signOut(auth);
      // Force a page refresh to update all components
      window.location.reload();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleLogin = () => {
    // Trigger the signup/login modal using the prop
    if (onShowSignupModal) {
      onShowSignupModal();
    }
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/">
            <img src={remfeeLogo} alt="RemFee" className="logo-image" />
            <span className="logo-text-after"> - An Amazon FBA Removal Calculator</span>
          </Link>
        </div>
        <div className="nav-links">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/blog" className="nav-link">Blog</Link>
          {isLoggedIn ? (
            <>
              <Link to="/history" className="nav-link">Calculation History</Link>
              <div className="user-info">
                <span className="user-email">{userEmail}</span>
                <button onClick={handleLogout} className="logout-button">
                  Logout
                </button>
              </div>
            </>
          ) : (
            <button onClick={handleLogin} className="login-button">Login</button>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navigation; 